import { sportingAPI } from 'services/sporting/api';

export const getPhoneNumbers = async (): Promise<string[]> => {
  return sportingAPI.service.getAvailablePhoneNumbers();
};
